import React from "react";
import Map, {
  Marker,
  MapConstant,
  MapControls,
  Popup,
} from "../../../../../lib/Map";
import {
  getDispatchUnassignedPickupMarker,
  getDispatchAssignedPickupMarker,
} from "../../../../mapComponents/mapHelper";
import { withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { observer, inject } from "mobx-react";
import { TerminalMarker } from "../../../../mapComponents/Markers";
import MapZoomChange from "../../../../../lib/Map/Trimble/components/MapZoomChange";
import { withAppConfig } from "../../../../../appConfigContext";
import { 
  isPickupOnMapActive,
  getPickupStopData,
} from "../../../../modules/Dispatch/RouteExecution/DriverMap/utils";
import PickupPopupInfo from "../../../../modules/Dispatch/RouteExecution/DriverMap/components/PickupPopupInfo";
import { getSpecialNeedsOptionsWithServiceLevel } from "../../../../modules/utils";
import { isPickupExistInGrid } from "./utils";
import MapHeader from "./components/MapHeader";
import { getPickupStatus, getPickupStatusTypeIcon } from "../../../../modules/Dispatch/RouteExecution/utils/pickupStatusTypeIcon";

@inject("DispatchStore")
@observer
class PickupMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAutoZoomEnabled: true,
      selectedPickups: [],
      selectedPickup: null,
    };
    this.pickupSelectedOnMap = false;
  }
  componentDidMount() {
    this.props.glEventHub.on("pickupSelectedOnGridPopup", this.pickupSelected);
  }
  componentWillUnmount() {
    this.props.glEventHub.off("pickupSelectedOnGridPopup", this.pickupSelected);
  }

  setRouteAnimation = (value) => {
    this.setState({
      isAutoZoomEnabled: value,
    });
  };

  pickupSelected = (selectedPickups) => {
    const isPickupInGrid = isPickupExistInGrid(
      selectedPickups,
      this.state.selectedPickup?.data?.pickupId
    );
    this.setState({
      selectedPickups,
      ...(!isPickupInGrid && { selectedPickup: null }),
    });
  };

  onMapClicked = () => {
    if (this.state.selectedPickup) {
      this.setState({
        selectedPickup: null,
      });
    }
    this.pickupSelectedOnMap = false;
  };

  onPickupMarkerClicked = (selectedPickup) => {
    let selectedPickups = [];
    const isActivePickup = isPickupOnMapActive(
      this.state.selectedPickups,
      selectedPickup.data.pickupId
    )
    if (!isActivePickup) {
      selectedPickups = [...this.state.selectedPickups, selectedPickup.data];
      this.pickupSelectedOnMap = true;
    } else {
      selectedPickups = this.state.selectedPickups.filter(
        (pickup) => pickup.pickupId !== selectedPickup.data.pickupId
      );
      this.pickupSelectedOnMap = false;
    }
    this.setState({ 
      selectedPickups,
      selectedPickup,
    });
    this.props.glEventHub.emit("pickupSelectedOnMapPopup", selectedPickups);
  };

  render() {
    const {
      theme,
      pickupList,
      userData: { userProfile },
      DispatchStore,
    } = this.props;
    const {selectedPickup, isAutoZoomEnabled} = this.state;
    const { location } = userProfile.terminal;
    let routesData;
    if (selectedPickup?.data?.driverId) {
      routesData = DispatchStore.getCurrentDriver(
        selectedPickup?.data?.driverId
      );
    }

    return (
      <>
        <MapHeader label="Pickups Map" setRouteAnimation={this.setRouteAnimation}/>
        <Map
          zoom={9}
          initialCenter={location}
          center={location}
          mapId="pickupsMap"
          mapTheme={theme.themeName}
          eventHub={this.props.glEventHub}
          mapConfig={this.props.configJSON?.maps}
          onClick={this.onMapClicked}
        >
          <MapControls
            controlOptions={{
              zoomControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              satelliteViewControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              reCenterMapControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
            }}
          />
          <Marker
            position={location}
            animation
            zIndex={2}
            forceUpdate
            isActiveShipment
          >
            <TerminalMarker
              data={userProfile.terminal}
              color={theme.terminalContentColor}
            />
          </Marker>
          <MapZoomChange thresholdZoomLevel={11}>
            {pickupList.length > 0 &&
              pickupList.map((pickup, i) => {
                const isPickupActive = isPickupOnMapActive(
                  this.state.selectedPickups,
                  pickup.pickupId
                );
                let pickupStop=null;
                if (pickup.driverId) {
                  pickupStop = getPickupStopData(
                    DispatchStore.routesList,
                    pickup
                  );
                }
                const activePickupZIndex = isPickupActive ? 1 : 0;
                return (
                  <Marker
                    position={{
                      lat: pickup.shipperLatitude,
                      lng: pickup.shipperLongitude,
                    }}
                    onClick={this.onPickupMarkerClicked}
                    zIndex={isAutoZoomEnabled ? activePickupZIndex : 0}
                    key={i}
                    isActiveShipment={isPickupActive}
                    data={pickup}
                  >
                    {pickup.driverId
                      ? getDispatchAssignedPickupMarker({
                          pickup,
                          isPickupActive,
                          stopSequence: pickupStop?.stopData?.stopSequence,
                          color: pickupStop?.stopColor,
                          stopData: pickupStop?.stopData,
                          theme,
                        })
                      : getDispatchUnassignedPickupMarker({
                          isActive: isPickupActive,
                          theme,
                          pickupCount: pickup.pickupNumberIdList?.length,
                          pickupStatus: getPickupStatus({
                            pickup,
                            terminalOffset: DispatchStore.terminalOffset,
                            newPickupDuration: this.props.configJSON?.newPickupDuration
                          })
                        })}
                  </Marker>
                );
              })}
          </MapZoomChange>
          {selectedPickup && this.pickupSelectedOnMap && (
            <Popup
              position={selectedPickup.position}
              key={`${selectedPickup.data.pickupId}_pickupPopup`}>
              <PickupPopupInfo
                specialNeeds={getSpecialNeedsOptionsWithServiceLevel(
                  DispatchStore.priorityAllShipmentList
                )}
                routesData={routesData}
                selectedPickup={selectedPickup.data}
                terminal={userProfile.terminal}
                routesList={DispatchStore.routesList}
                currentActiveRoutes={DispatchStore.currentActiveRoutes}
                marker={getPickupStatusTypeIcon({
                  theme,
                  status: getPickupStatus({
                    pickup: selectedPickup.data,
                    terminalOffset: this.props.DispatchStore.terminalOffset,
                    newPickupDuration: this.props.configJSON?.newPickupDuration
                  })
                })}
                glEventHub={this.props.glEventHub}
                showPickupHistory={false}
              />
            </Popup>
          )}
        </Map>
      </>
    );
  }
}

export default compose(
  withTheme(),
  withAppConfig,
)(PickupMap);
